import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import * as yup from 'yup'
import { get } from 'lodash'
import { FormField } from 'src/Components'
import Button from 'src/Components/buyers/Button'
import styles from './AddressForm.module.scss'

const propTypes = {
  fetch: PropTypes.func,
  address: PropTypes.string,
  zipcode: PropTypes.string
}

const SCHEMA = yup.object().shape({
  address: yup.string().required(),
  zipcode: yup
    .number()
    .required()
    .positive()
    .integer()
})

const initErrors = () => ({
  address: false,
  zipcode: false
})

const hasErrorType = (error, type) =>
  get(error, 'inner', []).some(e => e.path === type)

const getFormValue = (e, key) => get(e, ['target', 'elements', key, 'value'])

const ADDRESS = 'address'
const ZIPCODE = 'zipcode'

class AddressForm extends Component {
  state = {
    errors: initErrors()
  }

  handleSubmit = e => {
    e.preventDefault()

    const params = {
      address: getFormValue(e, ADDRESS),
      zipcode: getFormValue(e, ZIPCODE)
    }

    try {
      SCHEMA.validateSync(params, { abortEarly: false })

      this.setState({ errors: initErrors() })
      this.props.fetch(params)
    } catch (err) {
      this.setState({
        errors: {
          address: hasErrorType(err, ADDRESS),
          zipcode: hasErrorType(err, ZIPCODE)
        }
      })
    }
  }

  render () {
    const { address, zipcode } = this.props
    const { errors } = this.state

    const errorStyle = key => (errors[key] ? styles.error : '')

    return (
      <>
        <h2>
          <FormattedMessage
            id='AirDna.headline.howMuchCouldYouEarn'
            defaultMessage='If you rented your future home on Airbnb, how much could you potentially earn?'
          />
        </h2>

        <form className={styles.inputGroup} onSubmit={this.handleSubmit}>
          <FormField
            type='text'
            name={ADDRESS}
            defaultValue={address}
            required
            className={classnames(styles.address, errorStyle(address))}
          >
            <FormattedMessage
              id='FormField.label.address'
              defaultMessage='Address'
            />
          </FormField>
          <FormField.Zipcode
            name={ZIPCODE}
            title='Valid zip code'
            required
            defaultValue={zipcode}
            className={classnames(styles.zip, errorStyle(zipcode))}
          />
          <Button type='submit'>
            <FormattedMessage
              id='AirDna.address.search'
              defaultMessage='Search'
            />
          </Button>
        </form>
      </>
    )
  }
}

AddressForm.propTypes = propTypes

export default AddressForm
